import { component as defineComponent } from 'flightjs';

var entryReportButton = function () {
    this.after('initialize', function () {
        this.on('click', this.triggerReportEntry);
    });

    this.triggerReportEntry = function (event) {
        var data = this.$node.data();

        if (this.$node.is('[data-disabled]')) {
            event.stopPropagation();
            return;
        }

        document.dispatchEvent(
            new CustomEvent('ReportDesignRequested', {
                detail: {
                    reportUrl: data.entryReportUrl,
                    thumbnailUrl: data.entryReportThumbnailUrl,
                },
            })
        );
    };
};

export default defineComponent(entryReportButton);



// WEBPACK FOOTER //
// ./src/web/js/contest/ui/entry-report-button.js